import {
  GOT_CUSTOMER_RECENT_APPOINTMENTS,
  SET_IS_LOADING_RECENT_APPOINTMENTS,
  CLEAR_CUSTOMER_RECENT_APP_API_ERROR
} from "../actions/customerRecentAppointment";
import { customerRecentAppointmentsInitialState } from "../state/initialState";
import objectAssign from "object-assign";

export default (state = customerRecentAppointmentsInitialState, action) => {
  switch (action.type) {
    case GOT_CUSTOMER_RECENT_APPOINTMENTS: {
      if (action.data.status === "failed") {
        return objectAssign({}, state, {
          apiErrorReasons: action.data.reasons,
          isLoading: false
        });
      } else {
        const sideloadedServices = action.data.services
          ? action.data.services
          : null;
        const sideloadedResources = action.data.resources
          ? action.data.resources
          : null;
        let recentAppointments = action.data.bookings
          ? action.data.bookings
          : [];

        recentAppointments.map(booking => {
          if (sideloadedServices && sideloadedServices[booking.serviceid]) {
            const serviceName = sideloadedServices[booking.serviceid].name;
            booking.servicename = serviceName;
          }
          if (sideloadedResources && sideloadedResources[booking.resourceid]) {
            const resourceName = sideloadedResources[booking.resourceid].name;
            booking.resourcename = resourceName;
          }
        });

        return objectAssign({}, state, {
          customerRecentAppointments: recentAppointments,
          isLoading: false
        });
      }
    }
    case SET_IS_LOADING_RECENT_APPOINTMENTS: {
      return objectAssign({}, state, { isLoading: action.isLoading });
    }
    case CLEAR_CUSTOMER_RECENT_APP_API_ERROR: {
      return objectAssign({}, state, { apiErrorReasons: null });
    }
    default:
      return state;
  }
  return state;
};
